// extracted by mini-css-extract-plugin
export default {"list":"WorkerPerformanceGraph_list__sMdpc"};